/**
 * Адреса СОСЕДНИХ систем — одним местом на весь кабинет.
 *
 * Ссылка наружу отличается от нашей тем, что её нельзя проверить сборкой:
 * маршрут живёт в чужом репозитории, и опечатка в домене выяснится только
 * щелчком человека. Поэтому адрес собирается ОДНОЙ функцией и проверяется
 * тестом — вторая копия строки разошлась бы с первой на первом переезде
 * соседа.
 */

/** Система закупок: планы, выкуп и спрос по товару маркетплейса. */
export const SUPPLY = "https://supply.uni-renter.ru";

/**
 * Карточка товара в системе закупок.
 *
 * Номер — ТОВАР маркетплейса (`sMarketplace_competitor_product.id`), а не
 * карточка размера и не модель: закупки считают планы и выкуп товару целиком,
 * и размеры лежат у них внутри одной страницы. Тот же номер, которым
 * считаются заказы за неделю (`repo/mp_stat.py`).
 *
 * Ноль — «у карточки товар маркетплейса не проставлен». Тогда ссылки нет
 * вовсе: `/product/0` открылся бы у соседа пустой карточкой «товар не
 * найден», и щелчок увёл бы человека в чужую систему ни за чем.
 */
export function supplyProduct(productId: number): string {
  return productId > 0 ? `${SUPPLY}/product/${productId}` : "";
}
